'use strict';
import React from 'react';
import { FaMinus } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
interface DeleteCellProps {
  row: any;
  table: any;
  rest: any;
}
const DeleteCellV8: React.FC<any> = ({ row, table, ...rest }: any) => {
  const { t } = useTranslation();
  const meta = table.options.meta;
  const isDisabled = row.original.statusId === 3;
  const handleDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation(); // Prevent triggering row click events
    meta.deleteRow(row.id);
  };

  return (
    <div className="edit-cell-container text-center">
      {/* <button
        onClick={handleDelete}
        className={`btn btn-danger rounded-circle ${rest.className}`}
        name="delete"
        title="Delete Row"
        disabled={isDisabled}
      >
        <FaMinus />
      </button> */}
      <Button
        className={`btn-circle-sm btn-danger ${rest.className} text-white shadow-none`}
        onClick={handleDelete}
        data-toggle="tooltip"
        data-placement="left"
        title={t('Διαγραφή Εγγραφής')}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        <FaMinus />
      </Button>
    </div>
  );
};

export default DeleteCellV8;
